import React from 'react';

import { Icon } from '@rbilabs/components-library';

import { ScanAndPayLayout } from '../components/scan-and-pay-layout';

import { AddNewPaymentButton, Description } from './no-payment-method.styled';
import { INoPaymentMethod } from './types';

export const NoPaymentMethod = ({
  bodyText,
  addPaymentMethodButtonText,
  openAddPaymentMethodModal,
  ...props
}: INoPaymentMethod) => {
  const headerElement = <Icon icon="paymentCard" color="icon-default" width="32px" aria-hidden />;

  return (
    <ScanAndPayLayout headerElement={headerElement} {...props}>
      <>
        <Description content={bodyText} />
        <AddNewPaymentButton
          onClick={openAddPaymentMethodModal}
          data-testid="button-add-new-payment-method"
        >
          {addPaymentMethodButtonText}
        </AddNewPaymentButton>
      </>
    </ScanAndPayLayout>
  );
};
